import { getUser } from '@/api'
import * as Sentry from '@sentry/vue'
import { nanoid } from 'nanoid'
import { useSWRImmutable } from '@attensi/swr'
import { watch } from 'vue'

const uniqueKey = nanoid()

export const useUser = () => {
  const { data } = useSWRImmutable([uniqueKey], getUser)

  // Identify the user for Sentry once their profile resolves. Access control is
  // enforced centrally by the router guard (see router/index.ts), not here.
  watch(data, () => {
    if (!data.value) {
      return
    }

    Sentry.setUser({
      userId: data.value.id.toString(),
    })
  })

  return {
    user: data,
  }
}
